import httpClient from "./httpClient";
import { saveFilter, getFilter } from "./systems/local.objectFilters";

const objectsRef = lang => httpClient.get(`/objects/${lang}`);

const objectsCreate = (lang, data) => httpClient.post(`/objects/${lang}`, data);

const objectsGet = (id, lang) => httpClient.get(`/objects/${id}/${lang}`);

const objectsUpdate = (id, lang, data) =>
  httpClient.put(`/objects/${id}/${lang}`, data);

const objectsDelete = id => httpClient.delete(`/objects/${id}`);

const objectsFilterSave = filter => saveFilter(filter);
const objectsFilterGet = () => getFilter();

const objectsInfo = (lang, data) => httpClient.post(`/about/${lang}`, data);

export {
  objectsRef,
  objectsCreate,
  objectsGet,
  objectsUpdate,
  objectsDelete,
  objectsFilterSave,
  objectsFilterGet,
  objectsInfo
};
